/* CA scroll-reveal — progressive enhancement, honors prefers-reduced-motion. */
(function () {
  if (window.caMotionInit) return;
  window.caMotionInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var els = document.querySelectorAll('[data-ca-reveal]:not(.ca-reveal-armed):not(.ca-revealed)');
    if (!els.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ca-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ca-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      el.classList.add('ca-reveal-armed');
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  /* theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', init);
})();
